/* eslint-disable no-unused-vars */
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer/Footer';
import { Routes, Route, Outlet } from 'react-router-dom';
import AzedMessage from './components/AzedMessage';
import { toastError } from './api/ToastService';
import { ToastContainer } from 'react-toastify';
import styled from "styled-components";

import Product from "./Items4sale/Product";
import db from "./Items4sale/data/db";

const OutletContainer = styled.div` margin: auto; max-width: 1280px; padding-top: 20px; overflow : auto; `; 

const MiseEnPage = () => 
{ return (<><Header nbOfProducts={db.length} />
            <OutletContainer><Outlet /></OutletContainer>
            <Footer />
          </>
         )
}

function App() 
{ const { t } = useTranslation();
  const modalRef = useRef();
  const fileRef = useRef();
  //const [data, setData] = useState({});
  const [file, setFile] = useState(undefined);
  
  return (
    <><main className='main'>
         <div className='container'>
            <Routes>
               <Route path="/" element={<MiseEnPage />}>
                  <Route index element={<Product />} />
                  <Route path="azedmessage" element={<AzedMessage />} />
               </Route>         
            </Routes>
         </div>
      </main>

      <ToastContainer />
    </>
  );
}

export default App;